import { formatMoney } from 'partner360/features/keyInitiatives/ui/helpers/formatMoney'

export const formatChartValue =
  (activeCurrency: string, isFinancialMeasure?: boolean) => (value: number) => {
    if (!isFinancialMeasure) {
      return value
    }

    return formatMoney(value, activeCurrency)
  }
